
export const GET_ROOM_LIST_TYPES = {
  teamRoom: 1, // 组队房间列表
  myRoom: 2, // 我的房间列表
  latestRoom: 3, // 最近访问房间列表
}

// handleEnterRoom函数的type的map
export const ENTER_BY_INVITE_CODE_TYPES = {
  home: 0, // 首页输入框进入
  link: 1, // 邀请链接进入
  public: 2, // 通过public_id进入公开房间

  friend: 4, // 通过好友邀请进入
  recommend: 5, // 通过推荐房间进入
  hot: 6, // 通过热门房间进入
  search: 7, // 通过首页搜索进入
  follow: 8, // 通过好友列表跟随进入

  team_invite: 14, // 通过开黑邀约进入
  game_display: 15, // 通过正在游玩游戏展示弹窗进入
  redirect: 16, // 通过房间redirect进入
  activity_interval: 17, // 通过房间活动进入
  search_straight: 18, // 通过首页搜索直接进入

  publish_team: 20, // 发布组队成功后进入
  private_im: 21, // 通过群聊进入
  channel_im: 22, // 通过频道聊天进入
  group_im: 23, // 通过群聊进入

  global_team_chat: 24, // 通过全局组队进入
}

export const ROOM_NOTIFY_SETTING_TYPES = {
  extend: {
    key: 0,
    label: '跟随父级'
  },
  all: {
    key: 1,
    label: '所有消息',
  },
  only_at: {
    key: 2,
    label: '仅@被提及'
  },
  none: {
    key: 3,
    label: '无通知'
  }
}

export enum ROOM_NOTIFY_SETTING_ENUM {
  'extend',
  'all',
  'only_at',
  'none'
}

// 房间卡片编辑状态
export const ROOM_EDIT_APPLY_STATE = {
  not_apply: 0, // 未申请
  wait: 1, // 申请中
  pass: 2, // 通过
  refuse: 3 // 拒绝
}

// 房间卡片编辑已读
export const ROOM_EDIT_READ_STATE = {
  readed: 2, // 已读
  unread: 1, // 未读
}

// 热门房间申请状态
export const APPLY_HOT_STATUS = {
  cant_apply: -1, // 不满足条件
  unapply: 0, // 0: 未申请
  wait: 1, // 1: 申请中
  pass: 2, // 2: 通过
  reject: 3, // 3: 拒绝
}

export const DEFAULT_ROOM_BG = 'https://imgheybox.max-c.com/oa/2023/08/29/92c066014caedaf9c7be320ac595b4a0.png';
export const DEFAULT_ROOM_AVATAR = 'https://imgheybox.max-c.com/oa/2023/06/08/ccb123b89adc6c2c4adfc6e81d01440c.png'

export const ROOM_THEME_KEYTS = [
  'bg_color',
  'transparency',
  'blur_rate',
  'main_color_v2',
  'bar_color',
  'bar_main_color_v2',
  'bg_pic',
  'bg_pic_main_color',
  'show_channel_bar_filter',
  'can_decorate',

  // 防止切换两个不能展示左下角广告的房间时，左下角广告闪现
  'show_firm_room',
  'room_icon',
]

export const ROOM_ICON_ID_MAP = {
  'heybox-official': 1,
  'game-official': 2,
  'emcee': 3,
}

export const DISCOVER_ENTER_WAY = {
  SEARCH_BLURRY: 'home-search-blurred',
  SEARCH_STRIGHT: 'home-search-straight',
  HOT: 'hot',
  RECOMMEND: 'recommend',
  TEAM_INVITE: 'team_invite',
  IM: 'im',
  GROUP_IM: 'group-im',
  PRIVATE_IM: 'private-im',
}

// 安全管理 过滤里面的屏蔽类型
export const SAFETY_MANAGE_FIELDS = {
  WORDS: 'filter_words',
  LINKS: 'filter_urls',
  QRCODE: 'filter_qrcode',
}

// 安全管理 弹窗名称
export const SAFETY_MANAGE_DIALOG_NAME = {
  WORDS: 'SafetySettingDialog',
  LINKS: 'SafetySettingLinkDialog',
  QRCODE: 'SafetySettingQrCodeDialog',
  PUNISH: 'SafetySettingPunishDialog',
};

// 成员管理，用户进入房间的方式
export const INVITE_TYPE_STRING = {
  4: '好友邀请进入',
  5: '首页-推荐房间加入',
  6: '首页-热门房间加入',  
  7: '搜索结果列表中加入',
  8: '跟随好友状态进房',
  
  999: '-', // 房主
}

// 房间近期活动类型
export const ROOM_RECENT_EVENT_TYPE = {
  TEAM_INVITE: 1, // 开黑邀约
  ROOM_ACTIVITY: 2, // 房间活动
}

// 房间活动状态
export const ROOM_ACTIVITY_STATE = {
  STARTED: 1, // 已开始
  SOON: 2, // 即将开始 开始时间在当前时间之后的一小时内
  NOT_SOON: 3, // 即将开始 开始时间在当前时间之后的一小时以上
}

// 房间活动操作
export const ROOM_ACT_OPERATION = {
  CHECK: 0, // 查看详情
  JOIN: 1, // 参加
  JUMP: 2, // 加入频道
  SHARE: 3, // 分享
}

// 房间最大人数上限
export const ROOM_MEMBER_COUNT_LIMIT = {
  PRIVATE: 500, // 非公开房间
  PUBLIC: 5000, // 公开房间
  HOT: 2000000, // 热门房间
}


// 加入房间验证类型
export const ROOM_VERIFY_TYPE = {
  NONE: 0, // 无验证
  QUESTION: 1, // 问题验证
  VETTING: 2, // 加入审批
}

// 加入房间验证类型映射
export const ROOM_JOIN_VERIFY_TYPE_MAP = {
  [ROOM_VERIFY_TYPE.NONE]: '暂无验证',
  [ROOM_VERIFY_TYPE.QUESTION]: '问题验证',
  [ROOM_VERIFY_TYPE.VETTING]: '加入审批',
}

// 左边栏房间排序的方式
export const FOLDER_SORT_MODE = {
  DEFAULT: 0, // 默认
  MOST_VISITED: 1, // 最常访问
  RECENTLY_VISITED: 2, // 最近访问
}

// 默认通知设置
export const DEFAULT_NOTIFY_SETTING = {
  notify_type: 2,
};

// 社区房间交互类型
export const COMMUNITY_ROOM_INTERACT_TYPE = {
  SWITCH_COMMUNITY_ROOM: 0, // 请先开启社群房间开关
  ALREADY_HAD_PAGE_ROOM: 1, // 个人页已有房间
  SET_PUBLIC_ROOM: 2, // 请先设置为公开房间
  SET_DEFAULT_CHANNEL: 3, // 请先设置默认频道
  TURN_OFF_VERIFICATION: 4, // 请先关闭加入房间验证
}

// 房间认证类型
export enum ROOM_RECOGNITION_TYPE  {
  HEYBOX =  1, // 小黑盒官方认证
  VENDOR = 2, // 厂商认证
  ANCHOR = 3, // 主播认证
  COLLABORATION = 4, // 共建认证
  ACCOMPANY = 5,// 陪玩认证
}

// 房间组队卡片不可用选项
export const ROOM_TEAM_CARD_UNAVAILABLE_OPTIONS = {
  not_valid: {
    label: '当前邀请已失效',
    className: 'not-valid',
  },
  team_full: {
    label: '当前频道已满员',
    className: 'team-full',
  },
}